/**
 * Vendor
 */

/**
 * Components
 */
import dynamic from "next/dynamic";

import Toast from "components/atoms/Toast";
const FormDownload = dynamic(() => import("./FormDownload"), { ssr: false });

const FormDownloadModal = ({
  descriptionClass,
  checkboxTextClassName,
  show,
  onHide,
  typeFormDownload,
}) => {
  return (
    <>
      <Toast>
        {show && (
          <FormDownload
            descriptionClass={descriptionClass}
            checkboxTextClassName={checkboxTextClassName}
            show={show}
            onHide={onHide}
            typeFormDownload={typeFormDownload}
          />
        )}
      </Toast>
    </>
  );
};

export default FormDownloadModal;

/** ========== */
